export const LINK_CLICK_EVENT = "SFML_LINK_CLICK";
export const ITEM_CLICK_EVENT = "SFML_ITEM_CLICK";
export const ANCHOR_REQUEST_EVENT = "SFML_ANCHOR_REQUEST";
export const WAYFINDER_SCROLL_EVENT = "SFML_WAYFINDER_SCROLL";
export const STOREFRONT_TAP_EVENT = "SFML_STOREFRONT_TAP";
export const STOREFRONT_OPEN_EVENT = "SFML_STOREFRONT_OPEN";
export const STOREFRONT_EV_EVENT = "SFML_STOREFRONT_EV";
export const STOREFRONT_VIEW_EVENT = "SFML_STOREFRONT_VIEW";
export const STOREFRONT_SCROLL_EVENT = "SFML_STOREFRONT_SCROLL";

export const ANALYTICS_VIEWPORT_COVERAGE = 0.5;
export const ANALYTICS_ITEM_COVERAGE = 0.5;
export const ANALYTICS_EV_TIMER = 6000;
export const ANALYTICS_VIEW_TIMER = 500;



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/constants.ts